<template style="background-color:white">
  <section class="init_box" style="background-color: white">
    <div class="box-block">
      <p style="padding-top: 20px; padding-bottom: 20px; font-size: 16px">
        货架列表
      </p>
      <div style="text-align: right; padding-bottom: 10px">
        <span
          ><el-button type="primary" plain @click="addTop" size="mini"
            >添加一级货架</el-button
          ></span
        >
      </div>
      <el-tree
        :data="data"
        node-key="id"
        default-expand-all
        :expand-on-click-node="false"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>{{ node.label }}</span>
          <span>
            <el-button
              type="text"
              size="mini"
              @click="() => append(data)"
              v-if="node.level <= 3"
            >
              添加
            </el-button>
            <el-button type="text" size="mini" @click="() => editHandle(data)">
              编辑
            </el-button>
            <el-button
              type="text"
              size="mini"
              @click="() => remove(node, data)"
              v-if="node.level > 1"
            >
              删除
            </el-button>
          </span>
        </span>
      </el-tree>
    </div>

    <el-dialog
      title="请输入货架名称"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="addShow"
      width="370px"
      @close="closeDialog"
    >
      <el-form :model="addForm" ref="dataForm" label-position="left">
        <el-row>
          <el-col :span="24">
            <el-form-item>
              <el-input
                placeholder="请输入货架名称"
                auto-complete="off"
                v-model="addForm.name"
                style="width: 100%; margin-right: 55px"
                clearable
              >
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="addOk">保 存</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </section>
</template>
<script>
import {
  mktShelvesTree,
  mktShelvesAdd,
  mktShelvesRemove,
  mktShelvesEdit,
} from "../../api/api";
//货架管理
export default {
  name: "shelves",
  components: {},
  data() {
    return {
      data: [],
      addShow: false,
      addForm: { name: "" },
      currData: [],
    };
  },
  created() {
    this.getTree();
  },
  methods: {
    getTree() {
      mktShelvesTree().then((resultData) => {
        let { data, status, message } = resultData;
        if (status == 200) {
          this.data = data;
        }
      });
    },
    closeDialog() {
      this.addShow = false;
    },
    editHandle(data) {
      this.currData = data;
      this.addForm.name = data.label;
      this.addForm.id = data.id;
      this.addShow = true;
    },
    append(data) {
      this.currData = data;
      this.addShow = true;
    },
    addTop() {
      this.addForm.pid = 0;
      this.addShow = true;
    },
    addOk() {
      this.addForm.name = this.addForm.name.trim();
      if (this.addForm.id) {
        this.edit();
      } else {
        this.add();
      }
    },
    add() {
      if (this.addForm.pid !== 0) {
        this.addForm.pid = this.currData.id;
      }
      mktShelvesAdd(this.addForm).then((resultData) => {
        let { data, status, message } = resultData;
        if (status == 200) {
          this.addForm.pid = null;
          this.$message({
            message: message,
            type: "success",
          });
          const newChild = {
            id: data.id,
            label: this.addForm.name,
            children: [],
          };
          if (!this.currData.children) {
            this.$set(this.currData, "children", []);
          }
          this.currData.children.push(newChild);
          this.addShow = false;
          this.addForm = { name: "" };
          this.currData = [];
        } else {
          this.$message({
            message: message,
            type: "error",
          });
        }
      });
    },
    edit() {
      mktShelvesEdit(this.addForm).then((resultData) => {
        let { data, status, message } = resultData;
        if (status == 200) {
          this.$message({
            message: message,
            type: "success",
          });
          this.$set(this.currData, "label", this.addForm.name);
          this.addShow = false;
          this.addForm = { name: "" };
          this.currData = [];
        } else {
          this.$message({
            message: message,
            type: "error",
          });
        }
      });
    },
    remove(node, data) {
      mktShelvesRemove({ id: data.id }).then((resultData) => {
        let { status, message } = resultData;
        if (status == 200) {
          const parent = node.parent;
          const children = parent.data.children || parent.data;
          const index = children.findIndex((d) => d.id === data.id);
          children.splice(index, 1);
          this.$message({
            message: message,
            type: "success",
          });
        } else {
          this.$message({
            message: message,
            type: "error",
          });
        }
      });
    },

    renderContent(h, { node, data, store }) {
      return (
        <span class="custom-tree-node">
          <span>{node.label}</span>
          <span>
            <el-button
              size="mini"
              type="text"
              on-click={() => this.append(data)}
            >
              添加
            </el-button>
            <el-button
              size="mini"
              type="text"
              on-click={() => this.remove(node, data)}
            >
              删除
            </el-button>
          </span>
        </span>
      );
    },
  },
};
</script>
<style scoped>
.box-block {
  width: 1000px;
  min-height: 600px;
  margin: 10px auto;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  line-height: 30px;
  height: 30px;
  padding-right: 8px;
}

/deep/ .el-tree-node__content {
  height: 30px;
  border-bottom: 1px dotted #cccccc;
}
</style>



// WEBPACK FOOTER //
// src/views/market/Shelves.vue